export const CONFIRM_BUTTON_DISABLED = "CONFIRM_BUTTON_DISABLED";
export const SET_INDIVIDUAL_ATTACHMENTS = "SET_INDIVIDUAL_ATTACHMENTS";
export const SET_COMPANY_ATTACHMENTS = "SET_COMPANY_ATTACHMENTS";
export const SET_INFATH_WORKFLOW_OPEN = "SET_INFATH_WORKFLOW_OPEN";
export const SET_SELECTED_TIMED_AUCTION = "SET_SELECTED_TIMED_AUCTION";
export const SET_VIEW_REVIEW_STATUS_OPEN = "SET_VIEW_REVIEW_STATUS_OPEN";
export const SET_SELECTED_PARTICIPANT_REVIEW_ELEMENTS = "SET_SELECTED_PARTICIPANT_REVIEW_ELEMENTS";